// extracted by mini-css-extract-plugin
export default {"flexCenter":"scizers-wt-layouts-layout-flexCenter","wrapper":"scizers-wt-layouts-layout-wrapper","container":"scizers-wt-layouts-layout-container"};